// AuthDebugPanel.js - Mobile-friendly authentication debugging
import React, { useState, useEffect } from 'react'
import { useAuth } from '../auth/AuthContext'

const AuthDebugPanel = () => {
  const { getAuthDebugInfo, user, loading, initialized } = useAuth()
  const [debugInfo, setDebugInfo] = useState(null)
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (getAuthDebugInfo) {
      setDebugInfo(getAuthDebugInfo())
    }
  }, [getAuthDebugInfo, user, loading, initialized])

  // Only show debug panel in development or if URL contains debug=true
  const showDebug = process.env.NODE_ENV === 'development' ||
                   new URLSearchParams(window.location.search).get('debug') === 'true'

  if (!showDebug) return null

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(debugInfo, null, 2))
      alert('Debug info copied to clipboard!')
    } catch (err) {
      console.error('Failed to copy:', err)
      // Fallback for mobile browsers
      const textArea = document.createElement('textarea')
      textArea.value = JSON.stringify(debugInfo, null, 2)
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      alert('Debug info copied to clipboard!')
    }
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      backgroundColor: '#1f2937',
      color: 'white',
      padding: '10px',
      borderRadius: '8px',
      maxWidth: '300px',
      fontSize: '12px',
      zIndex: 1000,
      border: '1px solid #374151'
    }}>
      <div
        onClick={() => setExpanded(!expanded)}
        style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '8px' }}
      >
        🔍 Auth Debug {expanded ? '▼' : '▶'}
      </div>

      {expanded && debugInfo && (
        <div>
          <div style={{ marginBottom: '8px' }}>
            <strong>Status:</strong> {user ? '✅ Authenticated' : '❌ Not Authenticated'}
          </div>

          <div style={{ marginBottom: '8px' }}>
            <strong>Loading:</strong> {loading ? 'Yes' : 'No'}
          </div>

          <div style={{ marginBottom: '8px' }}>
            <strong>Device:</strong> {debugInfo.deviceInfo?.isMobile ? 'Mobile' : 'Desktop'}
          </div>

          <div style={{ marginBottom: '8px' }}>
            <strong>PostMessage Attempts:</strong> {debugInfo.postMessageAttempts}
          </div>

          <div style={{ marginBottom: '8px' }}>
            <strong>Parent Window:</strong> {debugInfo.hasParentWindow ? 'Yes' : 'No'}
          </div>

          <div style={{ marginBottom: '8px' }}>
            <strong>Cookies:</strong> {debugInfo.localStorage?.cookiesEnabled ? 'Enabled' : 'Disabled'}
          </div>

          <div style={{ marginBottom: '8px' }}>
            <strong>Local Session:</strong> {debugInfo.localStorage?.hasSupabaseToken ? 'Found' : 'Missing'}
          </div>

          {debugInfo.lastError && (
            <div style={{ marginBottom: '8px', color: '#f87171' }}>
              <strong>Last Error:</strong> {debugInfo.lastError}
            </div>
          )}

          <button
            onClick={copyToClipboard}
            style={{
              backgroundColor: '#3b82f6',
              color: 'white',
              border: 'none',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '11px',
              cursor: 'pointer'
            }}
          >
            Copy Debug Info
          </button>
        </div>
      )}
    </div>
  )
}

export default AuthDebugPanel